<div class="input-block">
    <div class="title"><strong>{{ title }}</strong>
        <employee-info-hint *ngIf="infoText" [infoText]="infoText"></employee-info-hint>
    </div>
    <input [type]="type"
           [class.invalid]="control.invalid && control.touched"
           [(ngModel)]="value"
           (input)="inputHandler($event)"
           [placeholder]="placeholder"
           [mask]="internalMask"
           [min]="_minValue"
           [max]="maxValue"
           [prefix]="internalPrefix"
           [maxlength]="maxLength"
           [disabled]="disabled">
    <div class="error-message" *ngIf="control && control.invalid && control.touched">
        <span *ngIf="control?.errors?.required">{{ requiredErrText }}</span>
        <span *ngIf="control?.errors?.pattern">{{ isEmail ? maskEmailErrText : maskPhoneErrText }}</span>
        <span *ngIf="control?.errors?.email">{{ maskEmailErrText }}</span>
        <span *ngIf="control?.errors?.nonDeloitteError">Could not be Deloitte user</span>
        <span *ngIf="control?.errors?.dateInPast">Cannot be future date</span>
        <span *ngIf="control?.errors?.dateInTheFuture">Date can't be in past</span>
        <span *ngIf="control?.errors?.maxDaysExceeded">Visit duration cannot exceed 90 days</span>
    </div>
</div>
